const VIEWED_SPRING_FOUR_RESOURCES = 'VIEWED_SPRING_FOUR_RESOURCES'
const REQUEST_START_BLOCKED = 'REQUEST_START_BLOCKED'
const REQUEST_SUBMIT_REMINDER = 'REQUEST_SUBMIT_REMINDER'
const REQUEST_COMPLETION_STATUS = 'REQUEST_COMPLETION_STATUS'
const ADDITIONAL_DOCUMENTS_UPLOADED = 'ADDITIONAL_DOCUMENTS_UPLOADED'

// Request step status
const REQUEST_STEP_HOUSEHOLD_DETAILS = 'REQUEST_STEP_HOUSEHOLD_DETAILS'
const REQUEST_STEP_FINANCIAL_HEALTH = 'REQUEST_STEP_FINANCIAL_HEALTH'
const REQUEST_STEP_PAYMENT = 'REQUEST_STEP_PAYMENT'
const REQUEST_STEP_EVENT_CATEGORIES = 'REQUEST_STEP_EVENT_CATEGORIES'
const REQUEST_STEP_CREATE_EVENTS = 'REQUEST_STEP_CREATE_EVENTS'
const REQUEST_STEP_EVENT_DOCUMENTATION = 'REQUEST_STEP_EVENT_DOCUMENTATION'
const REQUEST_STEP_EXPENSE_CATEGORIES = 'REQUEST_STEP_EXPENSE_CATEGORIES'
const REQUEST_STEP_EXPENSE_DOCUMENTATION = 'REQUEST_STEP_EXPENSE_DOCUMENTATION'
const REQUEST_STEP_SUMMARY = 'REQUEST_STEP_SUMMARY'
const REQUEST_STEP_NATURAL_DISASTER = 'REQUEST_STEP_NATURAL_DISASTER'
const REQUEST_STEP_REPRO_RIGHTS_DETAILS = 'REQUEST_STEP_REPRO_RIGHTS_DETAILS'
const REQUEST_STEP_REPRO_RIGHTS_DOCUMENTATION = 'REQUEST_STEP_REPRO_RIGHTS_DOCUMENTATION'
const REQUEST_STEP_REPRO_RIGHTS_SUMMARY = 'REQUEST_STEP_REPRO_RIGHTS_SUMMARY'

export default {
	VIEWED_SPRING_FOUR_RESOURCES,
	REQUEST_START_BLOCKED,
	REQUEST_SUBMIT_REMINDER,
	REQUEST_COMPLETION_STATUS,
	ADDITIONAL_DOCUMENTS_UPLOADED,
	REQUEST_STEP_HOUSEHOLD_DETAILS,
	REQUEST_STEP_FINANCIAL_HEALTH,
	REQUEST_STEP_PAYMENT,
	REQUEST_STEP_EVENT_CATEGORIES,
	REQUEST_STEP_CREATE_EVENTS,
	REQUEST_STEP_EVENT_DOCUMENTATION,
	REQUEST_STEP_EXPENSE_CATEGORIES,
	REQUEST_STEP_EXPENSE_DOCUMENTATION,
	REQUEST_STEP_SUMMARY,
	REQUEST_STEP_NATURAL_DISASTER,
	REQUEST_STEP_REPRO_RIGHTS_DETAILS,
	REQUEST_STEP_REPRO_RIGHTS_DOCUMENTATION,
	REQUEST_STEP_REPRO_RIGHTS_SUMMARY,
}
